import React from 'react'
import { motion, AnimatePresence } from 'motion/react'
import PrimaryNavigationBar from 'src/layouts/components/PrimaryNavigationBar'
import useNavigation from 'src/lib/hooks/useNavigation'
import SecondaryNavigationBar from 'src/layouts/components/SecondaryNavigationBar'
import { classNames } from 'src/lib/utils/helpers'

const NavigationBar = () => {
  const {
    getters: { sidebarOpen, isTablet }
  } = useNavigation()

  return (
    <div
      className={classNames('flex h-full py-2  scrollbar-hide w-full', isTablet ? 'w-auto' : '')}
      id='navigation-bar'
    >
      <div className='flex-shrink-0 pl-2 pr-1 z-10 overflow-hidden'>
        <PrimaryNavigationBar />
      </div>

      <AnimatePresence mode='wait'>
        {!sidebarOpen && !isTablet && (
          <motion.aside
            className='flex-shrink-0 z-12'
            layout
            initial={{ width: 245, opacity: 0, x: -100 }}
            animate={{ width: 245, opacity: 1, x: 0 }}
            exit={{ width: 0, opacity: 0, x: 0 }}
            transition={{
              duration: 0.3,
              delay: 0.1,
              type: 'spring',
              stiffness: 400,
              damping: 40
            }}
          >
            <div className='w-full'>
              <SecondaryNavigationBar />
            </div>
          </motion.aside>
        )}
      </AnimatePresence>
    </div>
  )
}

export default NavigationBar
